import { useEffect, useRef, useState } from "react";
import { api } from "../lib/api";
import { Megaphone } from "lucide-react";

export default function AdSlot({ placement, category, className = "" }) {
  const [ads, setAds] = useState([]);
  const tracked = useRef(false);

  useEffect(() => {
    let alive = true;
    tracked.current = false;
    api
      .get("/ads/serve", { params: { placement, category } })
      .then((res) => {
        if (!alive) return;
        setAds(res.data || []);
        if (!tracked.current) {
          tracked.current = true;
          (res.data || []).forEach((ad) => api.post(`/ads/${ad.id}/impression`).catch(() => {}));
        }
      })
      .catch(() => {});
    return () => { alive = false; };
  }, [placement, category]);

  if (ads.length === 0) return null;

  return (
    <div className={`space-y-4 ${className}`} data-testid={`ad-slot-${placement}`}>
      {ads.map((ad) => (
        <a
          key={ad.id}
          href={ad.link || "#"}
          target="_blank"
          rel="noopener noreferrer sponsored"
          data-testid={`ad-banner-${ad.id}`}
          onClick={() => api.post(`/ads/${ad.id}/click`).catch(() => {})}
          className="group relative block rounded-2xl overflow-hidden border border-gold/40 bg-teak"
        >
          {ad.image_url && (
            <img src={ad.image_url} alt={ad.title} loading="lazy" className="w-full h-36 sm:h-44 object-cover opacity-80 group-hover:opacity-100 group-hover:scale-[1.02] transition-all duration-500" />
          )}
          <div className="absolute inset-0 bg-gradient-to-r from-teak/90 via-teak/50 to-transparent" />
          <div className="absolute inset-0 flex items-center px-6 sm:px-8">
            <div>
              <p className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.25em] text-gold mb-2">
                <Megaphone className="w-3 h-3" /> Advertisement
              </p>
              <p className="font-display font-bold text-cream text-lg sm:text-xl max-w-md leading-snug">{ad.title}</p>
              <p className="text-xs text-cream/60 mt-1">{ad.advertiser}</p>
            </div>
          </div>
        </a>
      ))}
    </div>
  );
}
